/**
 * Renders a backend status string as a Carbon `Tag`, colored by
 * `statusIntent` (src/lib/statusIntent.ts) — see that file for the shared
 * word-list mapping this draws from.
 */
import { Tag } from '@carbon/react';
import { statusIntent, type StatusIntent } from '../../lib/statusIntent';

const TAG_TYPE: Record<StatusIntent, 'green' | 'red' | 'cyan' | 'gray'> = {
  positive: 'green',
  negative: 'red',
  attention: 'cyan',
  dormant: 'gray',
};

export interface StatusTagProps {
  /** Rendered verbatim as the tag's text — callers keep the backend's own status string, this only picks the color. */
  status: string;
}

export function StatusTag({ status }: StatusTagProps): React.JSX.Element {
  return <Tag type={TAG_TYPE[statusIntent(status)]}>{status}</Tag>;
}

export default StatusTag;
